import fetch from '@giro/shared-utils/fetch.util';

export default async function postApiAppsIdTokenService(integrationId) {
  return fetch(`apps/${integrationId}/token`, {
    method: 'POST',
    ms: 'DEBTS',
    auth: true,
  });
}
